/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ChangeLockStatusDto,
  FleetBatteryStatusDto,
  LocationDto,
  SyncVehicleParams,
  TelematicsStatusDto,
  TelematicsStatusLitePageDto,
  TelematicsSyncDto,
  VehicleLockStatusDto
} from '../../models';

import { customInstance } from '../../../../custom-instance';
import type { ErrorType , BodyType } from '../../../../custom-instance';




/**
 * Bulk minimal telemetry snapshot for every telematics-equipped vehicle: per vehicle only the newest tracking's GPS position, traction battery percentage, 12V voltage, odometer (km), ignition state and its timestamp. Replaces looping the per-vehicle status endpoint. The response is served from a short-lived server-side cache (~1 minute), so values may lag real time by at most the cache TTL.
 * @summary getVehicleStatusesLite
 */
export const getVehicleStatusesLite = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<TelematicsStatusLitePageDto>(
      {url: `/fleet/telematics/v1/vehicles/status/lite`, method: 'GET', signal
    },
      );
    }
  

export const getGetVehicleStatusesLiteQueryKey = () => {
    return [`/fleet/telematics/v1/vehicles/status/lite`] as const;
    }

    
export const getGetVehicleStatusesLiteQueryOptions = <TData = Awaited<ReturnType<typeof getVehicleStatusesLite>>, TError = ErrorType<null | null | null>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleStatusesLite>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVehicleStatusesLiteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVehicleStatusesLite>>> = ({ signal }) => getVehicleStatusesLite(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVehicleStatusesLite>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVehicleStatusesLiteQueryResult = NonNullable<Awaited<ReturnType<typeof getVehicleStatusesLite>>>
export type GetVehicleStatusesLiteQueryError = ErrorType<null | null | null>


export function useGetVehicleStatusesLite<TData = Awaited<ReturnType<typeof getVehicleStatusesLite>>, TError = ErrorType<null | null | null>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleStatusesLite>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVehicleStatusesLite>>,
          TError,
          Awaited<ReturnType<typeof getVehicleStatusesLite>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVehicleStatusesLite<TData = Awaited<ReturnType<typeof getVehicleStatusesLite>>, TError = ErrorType<null | null | null>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleStatusesLite>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVehicleStatusesLite>>,
          TError,
          Awaited<ReturnType<typeof getVehicleStatusesLite>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVehicleStatusesLite<TData = Awaited<ReturnType<typeof getVehicleStatusesLite>>, TError = ErrorType<null | null | null>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleStatusesLite>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary getVehicleStatusesLite
 */

export function useGetVehicleStatusesLite<TData = Awaited<ReturnType<typeof getVehicleStatusesLite>>, TError = ErrorType<null | null | null>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleStatusesLite>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVehicleStatusesLiteQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Battery status (percentage, cruising range, charging state) for one vehicle, served from the telematics database — no live provider round trip.
 * @summary getBatteryStatus
 */
export const getBatteryStatus = (
    vehicleId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<FleetBatteryStatusDto>(
      {url: `/fleet/telematics/v1/vehicles/${vehicleId}/battery`, method: 'GET', signal
    },
      );
    }
  

export const getGetBatteryStatusQueryKey = (vehicleId?: string,) => {
    return [`/fleet/telematics/v1/vehicles/${vehicleId}/battery`] as const;
    }

    
export const getGetBatteryStatusQueryOptions = <TData = Awaited<ReturnType<typeof getBatteryStatus>>, TError = ErrorType<null | null | null>>(vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBatteryStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBatteryStatusQueryKey(vehicleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBatteryStatus>>> = ({ signal }) => getBatteryStatus(vehicleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(vehicleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBatteryStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBatteryStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getBatteryStatus>>>
export type GetBatteryStatusQueryError = ErrorType<null | null | null>


export function useGetBatteryStatus<TData = Awaited<ReturnType<typeof getBatteryStatus>>, TError = ErrorType<null | null | null>>(
 vehicleId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBatteryStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBatteryStatus>>,
          TError,
          Awaited<ReturnType<typeof getBatteryStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBatteryStatus<TData = Awaited<ReturnType<typeof getBatteryStatus>>, TError = ErrorType<null | null | null>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBatteryStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBatteryStatus>>,
          TError,
          Awaited<ReturnType<typeof getBatteryStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBatteryStatus<TData = Awaited<ReturnType<typeof getBatteryStatus>>, TError = ErrorType<null | null | null>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBatteryStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary getBatteryStatus
 */

export function useGetBatteryStatus<TData = Awaited<ReturnType<typeof getBatteryStatus>>, TError = ErrorType<null | null | null>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBatteryStatus>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBatteryStatusQueryOptions(vehicleId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Forces a live battery refresh from the telematics provider and returns the fresh status. Slower than getBatteryStatus; may wake the vehicle's modem.
 * @summary refreshBattery
 */
export const refreshBattery = (
    vehicleId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<FleetBatteryStatusDto>(
      {url: `/fleet/telematics/v1/vehicles/${vehicleId}/battery/refresh`, method: 'POST', signal
    },
      );
    }
  


export const getRefreshBatteryMutationOptions = <TError = ErrorType<null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshBattery>>, TError,{vehicleId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof refreshBattery>>, TError,{vehicleId: string}, TContext> => {

const mutationKey = ['refreshBattery'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshBattery>>, {vehicleId: string}> = (props) => {
          const {vehicleId} = props ?? {};

          return  refreshBattery(vehicleId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RefreshBatteryMutationResult = NonNullable<Awaited<ReturnType<typeof refreshBattery>>>
    
    export type RefreshBatteryMutationError = ErrorType<null | null | null>

    /**
 * @summary refreshBattery
 */
export const useRefreshBattery = <TError = ErrorType<null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshBattery>>, TError,{vehicleId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof refreshBattery>>,
        TError,
        {vehicleId: string},
        TContext
      > => {

      const mutationOptions = getRefreshBatteryMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Sends an immobilizer command to the vehicle and returns the resulting lock status. For a Flespi tracker the call also wakes the tracker and waits for the command queue to drain, so it can block for up to about 30 seconds before it answers.
 * @summary changeImmobilizer
 */
export const changeImmobilizer = (
    vehicleId: string,
    changeLockStatusDto: BodyType<ChangeLockStatusDto>,
 ) => {
      
      
      return customInstance<VehicleLockStatusDto>(
      {url: `/fleet/telematics/v1/vehicles/${vehicleId}/immobilizer`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: changeLockStatusDto
    },
      );
    }
  


export const getChangeImmobilizerMutationOptions = <TError = ErrorType<null | null | null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeImmobilizer>>, TError,{vehicleId: string;data: BodyType<ChangeLockStatusDto>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof changeImmobilizer>>, TError,{vehicleId: string;data: BodyType<ChangeLockStatusDto>}, TContext> => {

const mutationKey = ['changeImmobilizer'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeImmobilizer>>, {vehicleId: string;data: BodyType<ChangeLockStatusDto>}> = (props) => {
          const {vehicleId,data} = props ?? {};

          return  changeImmobilizer(vehicleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChangeImmobilizerMutationResult = NonNullable<Awaited<ReturnType<typeof changeImmobilizer>>>
    export type ChangeImmobilizerMutationBody = BodyType<ChangeLockStatusDto>
    export type ChangeImmobilizerMutationError = ErrorType<null | null | null | null | null>

    /**
 * @summary changeImmobilizer
 */
export const useChangeImmobilizer = <TError = ErrorType<null | null | null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeImmobilizer>>, TError,{vehicleId: string;data: BodyType<ChangeLockStatusDto>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changeImmobilizer>>,
        TError,
        {vehicleId: string;data: BodyType<ChangeLockStatusDto>},
        TContext
      > => {

      const mutationOptions = getChangeImmobilizerMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Live GPS position of one vehicle, fetched from the telematics provider.
 * @summary getLocation
 */
export const getLocation = (
    vehicleId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<LocationDto>(
      {url: `/fleet/telematics/v1/vehicles/${vehicleId}/location`, method: 'GET', signal
    },
      );
    }
  

export const getGetLocationQueryKey = (vehicleId?: string,) => {
    return [`/fleet/telematics/v1/vehicles/${vehicleId}/location`] as const;
    }

    
export const getGetLocationQueryOptions = <TData = Awaited<ReturnType<typeof getLocation>>, TError = ErrorType<null | null | null>>(vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocation>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLocationQueryKey(vehicleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocation>>> = ({ signal }) => getLocation(vehicleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(vehicleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLocation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLocationQueryResult = NonNullable<Awaited<ReturnType<typeof getLocation>>>
export type GetLocationQueryError = ErrorType<null | null | null>


export function useGetLocation<TData = Awaited<ReturnType<typeof getLocation>>, TError = ErrorType<null | null | null>>(
 vehicleId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocation>>,
          TError,
          Awaited<ReturnType<typeof getLocation>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLocation<TData = Awaited<ReturnType<typeof getLocation>>, TError = ErrorType<null | null | null>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocation>>,
          TError,
          Awaited<ReturnType<typeof getLocation>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLocation<TData = Awaited<ReturnType<typeof getLocation>>, TError = ErrorType<null | null | null>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocation>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary getLocation
 */

export function useGetLocation<TData = Awaited<ReturnType<typeof getLocation>>, TError = ErrorType<null | null | null>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocation>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLocationQueryOptions(vehicleId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Fetches the vehicle's live position from the provider, persists it as the vehicle's known location and returns it.
 * @summary updateLocation
 */
export const updateLocation = (
    vehicleId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<LocationDto>(
      {url: `/fleet/telematics/v1/vehicles/${vehicleId}/location`, method: 'POST', signal
    },
      );
    }
  


export const getUpdateLocationMutationOptions = <TError = ErrorType<null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLocation>>, TError,{vehicleId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateLocation>>, TError,{vehicleId: string}, TContext> => {

const mutationKey = ['updateLocation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLocation>>, {vehicleId: string}> = (props) => {
          const {vehicleId} = props ?? {};

          return  updateLocation(vehicleId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateLocationMutationResult = NonNullable<Awaited<ReturnType<typeof updateLocation>>>
    
    export type UpdateLocationMutationError = ErrorType<null | null | null>

    /**
 * @summary updateLocation
 */
export const useUpdateLocation = <TError = ErrorType<null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLocation>>, TError,{vehicleId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateLocation>>,
        TError,
        {vehicleId: string},
        TContext
      > => {

      const mutationOptions = getUpdateLocationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Current central-lock and immobilizer status of one vehicle.
 * @summary getLockStatus
 */
export const getLockStatus = (
    vehicleId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<VehicleLockStatusDto>(
      {url: `/fleet/telematics/v1/vehicles/${vehicleId}/lock-status`, method: 'GET', signal
    },
      );
    }
  

export const getGetLockStatusQueryKey = (vehicleId?: string,) => {
    return [`/fleet/telematics/v1/vehicles/${vehicleId}/lock-status`] as const;
    }

    
export const getGetLockStatusQueryOptions = <TData = Awaited<ReturnType<typeof getLockStatus>>, TError = ErrorType<null | null | null>>(vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLockStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLockStatusQueryKey(vehicleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLockStatus>>> = ({ signal }) => getLockStatus(vehicleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(vehicleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLockStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLockStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getLockStatus>>>
export type GetLockStatusQueryError = ErrorType<null | null | null>


export function useGetLockStatus<TData = Awaited<ReturnType<typeof getLockStatus>>, TError = ErrorType<null | null | null>>(
 vehicleId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLockStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLockStatus>>,
          TError,
          Awaited<ReturnType<typeof getLockStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLockStatus<TData = Awaited<ReturnType<typeof getLockStatus>>, TError = ErrorType<null | null | null>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLockStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLockStatus>>,
          TError,
          Awaited<ReturnType<typeof getLockStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLockStatus<TData = Awaited<ReturnType<typeof getLockStatus>>, TError = ErrorType<null | null | null>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLockStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary getLockStatus
 */

export function useGetLockStatus<TData = Awaited<ReturnType<typeof getLockStatus>>, TError = ErrorType<null | null | null>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLockStatus>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLockStatusQueryOptions(vehicleId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Sends a central-lock command (lock/unlock) to the vehicle and returns the resulting lock status.
 * @summary changeLock
 */
export const changeLock = (
    vehicleId: string,
    changeLockStatusDto: BodyType<ChangeLockStatusDto>,
 ) => {
      
      
      return customInstance<VehicleLockStatusDto>(
      {url: `/fleet/telematics/v1/vehicles/${vehicleId}/lock-status`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: changeLockStatusDto
    },
      );
    }
  


export const getChangeLockMutationOptions = <TError = ErrorType<null | null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeLock>>, TError,{vehicleId: string;data: BodyType<ChangeLockStatusDto>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof changeLock>>, TError,{vehicleId: string;data: BodyType<ChangeLockStatusDto>}, TContext> => {

const mutationKey = ['changeLock'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeLock>>, {vehicleId: string;data: BodyType<ChangeLockStatusDto>}> = (props) => {
          const {vehicleId,data} = props ?? {};

          return  changeLock(vehicleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChangeLockMutationResult = NonNullable<Awaited<ReturnType<typeof changeLock>>>
    export type ChangeLockMutationBody = BodyType<ChangeLockStatusDto>
    export type ChangeLockMutationError = ErrorType<null | null | null | null>

    /**
 * @summary changeLock
 */
export const useChangeLock = <TError = ErrorType<null | null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeLock>>, TError,{vehicleId: string;data: BodyType<ChangeLockStatusDto>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changeLock>>,
        TError,
        {vehicleId: string;data: BodyType<ChangeLockStatusDto>},
        TContext
      > => {

      const mutationOptions = getChangeLockMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Current odometer reading in km for one vehicle; null when telematics has no recent mileage for it.
 * @summary getMileage
 */
export const getMileage = (
    vehicleId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/fleet/telematics/v1/vehicles/${vehicleId}/mileage`, method: 'GET', signal
    },
      );
    }
  

export const getGetMileageQueryKey = (vehicleId?: string,) => {
    return [`/fleet/telematics/v1/vehicles/${vehicleId}/mileage`] as const;
    }

    
export const getGetMileageQueryOptions = <TData = Awaited<ReturnType<typeof getMileage>>, TError = ErrorType<null | null | null>>(vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMileage>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMileageQueryKey(vehicleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMileage>>> = ({ signal }) => getMileage(vehicleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(vehicleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMileage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMileageQueryResult = NonNullable<Awaited<ReturnType<typeof getMileage>>>
export type GetMileageQueryError = ErrorType<null | null | null>


export function useGetMileage<TData = Awaited<ReturnType<typeof getMileage>>, TError = ErrorType<null | null | null>>(
 vehicleId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMileage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMileage>>,
          TError,
          Awaited<ReturnType<typeof getMileage>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMileage<TData = Awaited<ReturnType<typeof getMileage>>, TError = ErrorType<null | null | null>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMileage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMileage>>,
          TError,
          Awaited<ReturnType<typeof getMileage>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMileage<TData = Awaited<ReturnType<typeof getMileage>>, TError = ErrorType<null | null | null>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMileage>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary getMileage
 */

export function useGetMileage<TData = Awaited<ReturnType<typeof getMileage>>, TError = ErrorType<null | null | null>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMileage>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMileageQueryOptions(vehicleId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Combined telematics status for one vehicle: battery block, last tracking timestamp, ignition state and key-fob status.
 * @summary getActualStatus
 */
export const getTelematicsStatus = (
    vehicleId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<TelematicsStatusDto>(
      {url: `/fleet/telematics/v1/vehicles/${vehicleId}/status`, method: 'GET', signal
    },
      );
    }
  

export const getGetTelematicsStatusQueryKey = (vehicleId?: string,) => {
    return [`/fleet/telematics/v1/vehicles/${vehicleId}/status`] as const;
    }

    
export const getGetTelematicsStatusQueryOptions = <TData = Awaited<ReturnType<typeof getTelematicsStatus>>, TError = ErrorType<null | null | null>>(vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTelematicsStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTelematicsStatusQueryKey(vehicleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTelematicsStatus>>> = ({ signal }) => getTelematicsStatus(vehicleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(vehicleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTelematicsStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTelematicsStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getTelematicsStatus>>>
export type GetTelematicsStatusQueryError = ErrorType<null | null | null>


export function useGetTelematicsStatus<TData = Awaited<ReturnType<typeof getTelematicsStatus>>, TError = ErrorType<null | null | null>>(
 vehicleId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTelematicsStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTelematicsStatus>>,
          TError,
          Awaited<ReturnType<typeof getTelematicsStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTelematicsStatus<TData = Awaited<ReturnType<typeof getTelematicsStatus>>, TError = ErrorType<null | null | null>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTelematicsStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTelematicsStatus>>,
          TError,
          Awaited<ReturnType<typeof getTelematicsStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTelematicsStatus<TData = Awaited<ReturnType<typeof getTelematicsStatus>>, TError = ErrorType<null | null | null>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTelematicsStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary getActualStatus
 */

export function useGetTelematicsStatus<TData = Awaited<ReturnType<typeof getTelematicsStatus>>, TError = ErrorType<null | null | null>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTelematicsStatus>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTelematicsStatusQueryOptions(vehicleId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Deep link into the telematics provider's support portal for this vehicle's device; null when the provider has no support page.
 * @summary getSupportPageLink
 */
export const getSupportPageLink = (
    vehicleId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/fleet/telematics/v1/vehicles/${vehicleId}/support-link`, method: 'GET', signal
    },
      );
    }
  

export const getGetSupportPageLinkQueryKey = (vehicleId?: string,) => {
    return [`/fleet/telematics/v1/vehicles/${vehicleId}/support-link`] as const;
    }

    
export const getGetSupportPageLinkQueryOptions = <TData = Awaited<ReturnType<typeof getSupportPageLink>>, TError = ErrorType<null | null | null>>(vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportPageLink>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupportPageLinkQueryKey(vehicleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupportPageLink>>> = ({ signal }) => getSupportPageLink(vehicleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(vehicleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSupportPageLink>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSupportPageLinkQueryResult = NonNullable<Awaited<ReturnType<typeof getSupportPageLink>>>
export type GetSupportPageLinkQueryError = ErrorType<null | null | null>


export function useGetSupportPageLink<TData = Awaited<ReturnType<typeof getSupportPageLink>>, TError = ErrorType<null | null | null>>(
 vehicleId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportPageLink>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupportPageLink>>,
          TError,
          Awaited<ReturnType<typeof getSupportPageLink>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSupportPageLink<TData = Awaited<ReturnType<typeof getSupportPageLink>>, TError = ErrorType<null | null | null>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportPageLink>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupportPageLink>>,
          TError,
          Awaited<ReturnType<typeof getSupportPageLink>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSupportPageLink<TData = Awaited<ReturnType<typeof getSupportPageLink>>, TError = ErrorType<null | null | null>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportPageLink>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary getSupportPageLink
 */

export function useGetSupportPageLink<TData = Awaited<ReturnType<typeof getSupportPageLink>>, TError = ErrorType<null | null | null>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupportPageLink>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSupportPageLinkQueryOptions(vehicleId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Refreshes one vehicle's tracking from its telematics provider now and answers what was written. A sleeping vehicle is only woken when forceAwake is true; otherwise it is left asleep and nothing is written. Not affected by the scheduled sync's on/off switch: this is a deliberate single-vehicle action.
 * @summary syncVehicle
 */
export const syncVehicle = (
    vehicleId: string,
    params?: SyncVehicleParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<TelematicsSyncDto>(
      {url: `/fleet/telematics/v1/vehicles/${vehicleId}/sync`, method: 'POST',
        params, signal
    },
      );
    }
  


export const getSyncVehicleMutationOptions = <TError = ErrorType<null | null | null | null | null | null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncVehicle>>, TError,{vehicleId: string;params?: SyncVehicleParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof syncVehicle>>, TError,{vehicleId: string;params?: SyncVehicleParams}, TContext> => {

const mutationKey = ['syncVehicle'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncVehicle>>, {vehicleId: string;params?: SyncVehicleParams}> = (props) => {
          const {vehicleId,params} = props ?? {};

          return  syncVehicle(vehicleId,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SyncVehicleMutationResult = NonNullable<Awaited<ReturnType<typeof syncVehicle>>>
    
    export type SyncVehicleMutationError = ErrorType<null | null | null | null | null | null | null | null>

    /**
 * @summary syncVehicle
 */
export const useSyncVehicle = <TError = ErrorType<null | null | null | null | null | null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncVehicle>>, TError,{vehicleId: string;params?: SyncVehicleParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof syncVehicle>>,
        TError,
        {vehicleId: string;params?: SyncVehicleParams},
        TContext
      > => {

      const mutationOptions = getSyncVehicleMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Sends a wake-up command to the vehicle's telematics device (supported providers only). Fire-and-forget: an empty 200 means the command was dispatched.
 * @summary wakeUp
 */
export const wakeUp = (
    vehicleId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<null>(
      {url: `/fleet/telematics/v1/vehicles/${vehicleId}/wake-up`, method: 'POST', signal
    },
      );
    }
  


export const getWakeUpMutationOptions = <TError = ErrorType<null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof wakeUp>>, TError,{vehicleId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof wakeUp>>, TError,{vehicleId: string}, TContext> => {

const mutationKey = ['wakeUp'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof wakeUp>>, {vehicleId: string}> = (props) => {
          const {vehicleId} = props ?? {};

          return  wakeUp(vehicleId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WakeUpMutationResult = NonNullable<Awaited<ReturnType<typeof wakeUp>>>
    
    export type WakeUpMutationError = ErrorType<null | null | null>

    /**
 * @summary wakeUp
 */
export const useWakeUp = <TError = ErrorType<null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof wakeUp>>, TError,{vehicleId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof wakeUp>>,
        TError,
        {vehicleId: string},
        TContext
      > => {

      const mutationOptions = getWakeUpMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    